<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>Send Notification</template>
    <v-row>
      <v-col>
        <v-text-field
          label="Title"
          v-model="title"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          label="Body"
          v-model="body"
          :outlined="outlinedInputs"
          hide-details
        ></v-textarea>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSend" :disabled="!isValid">Send</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  components: { BasicDialog },
  name: "send-notification-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      title: "",
      body: "",
    };
  },
  computed: {
    isValid() {
      return this.title != "" && this.body != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.title = "";
        this.body = "";
      }
    },
  },
  methods: {
    onSend() {
      this.$emit("send", {
        title: this.title,
        body: this.body,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/itineraries/notifications/SendNotificationDialog.vue